import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "pdf",
  "use": "pdf-usage",
  "viewBox": "0 0 20 21",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 21\" id=\"pdf\"><path d=\"M18 .5H6c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2v-12c0-1.1-.9-2-2-2Zm0 14H6v-12h12v12ZM2 4.5H0v14c0 1.1.9 2 2 2h14v-2H2v-14Zm12 6v-3c0-.55-.45-1-1-1h-2v5h2c.55 0 1-.45 1-1Zm-2-3h1v3h-1v-3Zm4 2h1v-1h-1v-1h1v-1h-2v5h1v-2Zm-8 0h1c.55 0 1-.45 1-1v-1c0-.55-.45-1-1-1H7v5h1v-2Zm0-2h1v1H8v-1Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol